<template>
    <div class="view-pay-slip">
        <div>
            <v-row class="mx-3">
                <!-- <v-col class="text-left">
                <v-checkbox v-model="printTwoCopies" label="Print 2 Copies"></v-checkbox>
                </v-col> -->
                <v-col class="text-right">
                <!-- <v-btn elevation="1" color="white" v-if="!isLoading && receipt != null && receipt.is_latest" @click="showDeleteConfirmation = true" class="mr-2">Delete</v-btn> -->
                <v-btn elevation="1" color="white" v-if="!isLoading" @click="printPdf">Print</v-btn>
                <v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
                </v-col>
            </v-row>
            <PayslipTable v-if="payslip && payslipSettings" :payslip="payslip" :payslipSettings="payslipSettings"/>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import Helper from "@utils/misc";
import PayslipTable from "@components/payroll/PayslipTable";


export default {
    name: 'ViewPayslip',
    data(){
        return {
            payslip:null,
            payslipSettings: null,
        }
    },
    components:{
        PayslipTable,
    },
    computed:{
        ...mapGetters([
            "currentUser",
            "currentInstitution",
            "accessToken",
            "isLoading",
        ]),
        essentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },
    },
    methods:{
        ...mapActions(["setLoading"]),
        async getPayslipData(){
            var url = Helper.addUrlParams(endpoints.payslip,[`id=${this.payslip_id}`])
            this.payslip = await api.call(
                this.essentials,
                url
            );
        },  
        
        async getPayslipSettings(){
            this.payslipSettings = await api.call(this.essentials, endpoints.payslipSettings)
        },

        async printPdf() {
            var windowOptions =
                "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=1024,height=768";
            window.open(
                "/payroll/payslips/print/" +
                this.payslip_id,
                "Print Payslip",
                windowOptions
            );
        },
    },
    created(){
        // if(this.$route.params.payslip_id){
            this.payslip_id = this.$route.params.payslip_id
            this.getPayslipData();  
            this.getPayslipSettings();
        // }
        // else{
        //     this.$router.push({ name : 'PayrollDashboard' })
        // }
    },
}
</script>
